import React, { Component } from 'react';
import {
  Button,
  ButtonToolbar,
  FormGroup,
  ControlLabel,
  FormControl,
  Panel,
  Col,
  Row,
  Form,
} from 'react-bootstrap';
import { compose } from 'recompose';
import { withRouter, Link } from 'react-router-dom';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { routerProps } from '../../propTypes';

import logo from '../../images/HSI_logo_no_subtext.png';
import logoSmall from '../../images/HSI_logo_no_subtext _small.png';
import './style.css';

import LoginError from './LoginError';

import { loginUser, loginClear } from '../../features/authentication/actions';
import {
  getLoginErrorMessage,
  getLoginErrorStatus,
  getLoginLoadingStatus,
} from '../../features/authentication/selectors';

const proptypes = exact({
  errorMessage: PropTypes.string.isRequired,
  errorStatus: PropTypes.bool.isRequired,
  loadingStatus: PropTypes.bool.isRequired,
  loginUserAction: PropTypes.func.isRequired,
  loginClearAction: PropTypes.func.isRequired,

  bsStyle: PropTypes.string,
  ...routerProps,
});

export class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
    };
    this.handleLogin = this.handleLogin.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  async handleLogin() {
    const { loginUserAction, history } = this.props;
    const { email, password } = this.state;
    await loginUserAction(email, password);
    history.push('/');
  }

  handleCancel() {
    this.setState({
      email: '',
      password: '',
    });
  }

  render() {
    const {
      errorMessage,
      errorStatus,
      loadingStatus,
      loginClearAction,
    } = this.props;
    const { email, password } = this.state;

    return (
      <div>
        <Panel>
          <Row>
            <Col xs={1} md={4}>
              <img className="hidden-xs" src={logo} alt="logo" />
              <img className="visible-xs" src={logoSmall} alt="logo" />
            </Col>
          </Row>

          <Form>
            <Row>
              <Col xs={12} md={12}>
                <h3>Hurricane Service Inc.</h3>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <FormGroup>
                  <ControlLabel>E-mail:</ControlLabel>
                  <FormControl
                    onChange={this.handleChange}
                    name="email"
                    type="text"
                    placeholder="Enter your e-mail address"
                    value={email}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <FormGroup>
                  <ControlLabel>Password:</ControlLabel>
                  <FormControl
                    onChange={this.handleChange}
                    name="password"
                    type="password"
                    placeholder="Enter your password"
                    value={password}
                  />
                </FormGroup>
              </Col>
            </Row>
            <ButtonToolbar className="hidden-xs">
              <Button
                disabled={loadingStatus}
                className="pull-right"
                bsStyle="primary"
                onClick={this.handleLogin}
              >
                Submit
              </Button>
            </ButtonToolbar>
            <Row className="visible-xs">
              <Col xs={12}>
                <Button
                  disabled={loadingStatus}
                  bsStyle="primary"
                  style={{ width: '100%' }}
                  onClick={this.handleLogin}
                >
                  Submit
                </Button>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <Link to="./password-reset/request/">Forgot Password?</Link>
              </Col>
            </Row>
          </Form>
          <LoginError
            show={errorStatus}
            message={errorMessage}
            onOkay={loginClearAction}
          />
        </Panel>
      </div>
    );
  }
}

Login.propTypes = proptypes;


const mapStateToProps = (state) => {
  return {
    errorMessage: getLoginErrorMessage(state),
    errorStatus: getLoginErrorStatus(state),
    loadingStatus: getLoginLoadingStatus(state),
  };
};

const mapDispatchToProps = {
  loginUserAction: loginUser,
  loginClearAction: loginClear,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withRouter,
);

export default enhance(Login);
